import { Injectable, Inject } from "@angular/core";
import { Actions, ofType, createEffect } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap, tap } from "rxjs/operators";

import { ConfigurationActions } from "@actions/index";
import { CertificateHistoricalActions } from "@actions/configuration";
import { TableStorageService } from "@services/table-storage.service";
import { CertificateHistoricalModel } from "@models/configuration/certificate-historical.model";
import { isObject } from 'util';

@Injectable()
export class CertificateHistoricalEffects {
  // CertificateHistoricals Effects
  searchCertificateHistoricals$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CertificateHistoricalActions.searchCertificateHistoricals),
      switchMap(({ action }) =>
        this.tableStorageService.search$(action).pipe(
          map((CertificateHistoricals: CertificateHistoricalModel[]) =>
            CertificateHistoricalActions.searchCertificateHistoricalsSuccess({ CertificateHistoricals })
          ),
          catchError((error) =>
            of(ConfigurationActions.configurationError({ error }),CertificateHistoricalActions.resetLoading())
          )
        )
      )
    )
  );


  createCertificateHistoricals$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CertificateHistoricalActions.createCertificateHistorical),
      switchMap(({ action }) =>
        this.tableStorageService.create$(action).pipe(
          map((CertificateHistorical: CertificateHistoricalModel) =>
            CertificateHistoricalActions.createCertificateHistoricalSuccess({ CertificateHistorical })
          ),
          catchError((error) =>
            of(ConfigurationActions.configurationError({ error }),CertificateHistoricalActions.resetLoading())
          )
        )
      )
    )
  );

  updateCertificateHistoricals$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CertificateHistoricalActions.updateCertificateHistorical),
      switchMap(({ action }) =>
        this.tableStorageService.update$(action).pipe(
          map((CertificateHistorical: CertificateHistoricalModel) =>
            CertificateHistoricalActions.updateCertificateHistoricalSuccess({ CertificateHistorical })
          ),
          catchError((error) =>
            of(ConfigurationActions.configurationError({ error }),CertificateHistoricalActions.resetLoading())
          )
        )
      )
    )
  );

  deleteCertificateHistoricals$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CertificateHistoricalActions.deleteCertificateHistorical),
      switchMap(({ action }) =>
        this.tableStorageService.delete$(action).pipe(
          map((CertificateHistorical: CertificateHistoricalModel) =>
            CertificateHistoricalActions.deleteCertificateHistoricalSuccess({ CertificateHistorical })
          ),
          catchError((error) =>
            of(ConfigurationActions.configurationError({ error }),CertificateHistoricalActions.resetLoading())
          )
        )
      )
    )
  );
  /////////////
  constructor(
    private actions$: Actions,
    @Inject("TableStorageService")
    private tableStorageService: TableStorageService<CertificateHistoricalModel>
  ) {}
}
